import {
    useDropzone,
} from 'react-dropzone'
import DropZone from 'app/shared-components/DropZone/DropZone'
import useParseCsvFile from './hooks/useParseCsvFile'

type Props = {
    onLoadData: (data: Record<string, any>[]) => void,
    mandatoryFields: string[],
}

const CsvDataLoader = ({
    onLoadData,
    mandatoryFields,
}: Readonly<Props>) => {
    const parseCsvFile = useParseCsvFile({
        onLoadData,
        mandatoryFields,
    })

    const {
        getRootProps,
        getInputProps,
        open,
        isDragActive,
        isDragReject,
    } = useDropzone({
        onDrop: parseCsvFile,
        maxFiles: 1,
        accept: {
            'text/csv': [],
        },
    })

    return (
        <DropZone
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            isDragActive={isDragActive}
            isDragReject={isDragReject}
            open={open}
        />
    )
}

export default CsvDataLoader
